const Edata=[
    {
    "id": 5,
    "img":"https://demo.tagdiv.com/newspaper_today_news_pro/wp-content/uploads/2022/03/16-1024x719.jpg",
    "title": "JOE JONAS SAYS HE ‘HAD A BLAST’ TURNING INTO A BRIDGERTON FOR NEW TANQUERAY CAMPAIGN",
    "des":"We all know that Oscar nominees get treated to incredible swag bags every year...",
    "category": "1",
    },
    {
    "id": 6,
    "img":"https://demo.tagdiv.com/newspaper_today_news_pro/wp-content/uploads/2022/03/15-1024x764.jpg",
    "title": "VANCE JOY RELEASES A ‘CHILLED’ AND ‘HYPNOTIC’ LIVE VIDEO VERSION OF ‘DON’T FADE’",
      "des":"We all know that Oscar nominees get treated to incredible swag bags every year...",
    "category": "2",
    },
    {
    "id": 7,
    "img":"https://demo.tagdiv.com/newspaper_today_news_pro/wp-content/uploads/2022/03/14-1024x683.jpg",
    "title": "BRELAND OPENS UP ABOUT HIS FIRST AWARD SHOW NOMINATION: ‘I DON’T TAKE IT FOR GRANTED’",
      "des":"We all know that Oscar nominees get treated to incredible swag bags every year...",
    "category": "3",
    },
]
export default Edata;